import { DotcEnums } from 'src/common/contracts/enums/dotc'
import { UpdateOfferParams } from 'src/thirdweb/dotc'
import { UpdatableOfferFields } from './types'

export const buildUpdatedOffer = (
  update: UpdatableOfferFields
): UpdateOfferParams['updatedOffer'] => {
  return {
    commsLink: update.commsLink ?? '',
    takingOfferType: DotcEnums.TakingOfferType.NoType, // NOT NEEDED
    offerPrice: {
      offerPricingType: DotcEnums.OfferPricingType.NoType, // NOT NEEDED
      unitPrice: BigInt(0), // NOT NEEDED
      percentage: BigInt(0), // NOT NEEDED
      percentageType: DotcEnums.PercentageType.NoType, // NOT NEEDED
    },
    specialAddresses: update.specialAddresses ?? [],
    authorizationAddresses: update.authorizationAddresses ?? [],
    expiryTimestamp: BigInt(update.expiryTimestamp ?? 0),
    timelockPeriod: BigInt(update.timelockPeriod ?? 0),
    terms: update.terms ?? '',
  }
}
